import React, { useContext, useMemo } from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _matchResultTypes, matchDisplayTypes } from '../../cnr/reducers/SportsMatchReducer';
import { sportsShowTypes } from '../../cnr/reducers/SportsSeasonReducer';
import MatchScoreButtons from './MatchScoreButtons';

const MatchOptions = (props) => {

  const { handleShowOptions } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers } = sportsSeasonContext ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchScheduleType, matchDisplayType } = seasonMatches_state ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true } = sportsMatch_state ?? {}
  const { _resultsStatus } = match_true ?? {}
  const { scoreType } = _resultsStatus ?? {}
  const { away, home } = match_true ?? {}

  let allowRtScoring = true;

  switch (scoreType) {
    case _matchResultTypes.matchDay:
      allowRtScoring = false
      break;
    default:
    // nothingFv
  }

  const handleShow_matchScoreTable = (e) => {
    e && e.stopPropagation()
    const opts = { sportsShowType: sportsShowTypes.updateResults, matchKey: match_true?._itemKey }
    sportsSeason_handlers.handleShow_sportsElem(opts)
  }

  const handleShow_matchRtScoring = (e) => {
    e && e.stopPropagation()
    seasonMatches_handlers && seasonMatches_handlers.handleSelect_currentMatch(match_true, matchDisplayTypes.realtimeScoring)
  }

  const match_options = useMemo(() => <div className='match-score-btns opts' onClick={(e) => { handleShowOptions(e) }}>
    <div>
      <Button size='mini' color={'blue'} disabled={!allowRtScoring} onClick={(e) => { handleShow_matchRtScoring(e) }} >{'Realtime Scoring'}</Button>
      <Button size='mini' color={'blue'} onClick={(e) => { handleShow_matchScoreTable(e) }} >{'Update Results'}</Button>
    </div>
  </div>, [])

  const content_teams = useMemo(() => {
    return <div className='match-score-teams'>
      <div>{away?.name}</div>
      <Label onClick={(e) => { handleShowOptions(e) }} color='black' size='tiny'>{'Result Options'}<Icon name='delete' /></Label>
      <div>{home?.name}</div>
    </div>
  }, [away, home])

  const content_match = (content) => {
    return <div className='match-score-content opts'>
      {content_teams}
      {content}
    </div>
  }

  switch (matchDisplayType) {
    case matchDisplayTypes.matchOptions:
      return content_match(match_options)
    case matchDisplayTypes.realtimeScoring:
      return <MatchScoreButtons matchScheduleType={matchScheduleType} />
    default:
      return content_match(match_options)
  }

}

export default MatchOptions